import React from "react";

export default function DocumentItem(mediaObject) {
  const { code, url, title } = mediaObject;

  return (
    <li key={code} className='dealer-doc'>
      <a href={url} target="_blank"><i className='fa fa-file-pdf-o' aria-hidden="true" /> {title}</a>
    </li>
  );
}
